module.exports = __webpack_public_path__ + "img/empty.ded18749.png";